import type { Profile } from '@entities/agent-contract';

import { AddressType } from '@shared/index';

import type { ProfileAddressDetailsData } from '../model';

export const getAdresses = (
  addressesAgents?: Profile['addressesAgents']
): ProfileAddressDetailsData => {
  const agentAddress = addressesAgents?.find(
    ({ addressType }) => addressType === AddressType.REGISTRATION
  );
  const agentActualAddress = addressesAgents?.find(
    ({ addressType }) => addressType === AddressType.ACCOMMODATION
  );

  return {
    address: agentAddress?.address,
    actualAddress: agentActualAddress?.address,
  };
};
